<template>
<div class="chapter">
<div class="inner_page">
<p class="imagefp"><a id="page_iii"><img alt="The Quilter's Apprentice, by Jennifer Chiaverini, Simon &amp; Schuster" class="imagefp" src="images/title.jpg"/></a></p><a id="page_iii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1981de61